import {
    GET_MEMBERVALIDATION_INFO_LOADING, MEMBERVALIDATION_DATA_SUCCESS,
    MEMBERVALIDATION_DATA_ERROR, MEMBERVALIDATION_DATA_RESET,
    MEMBERVALIDATION_LOADING_RESET, GET_MEMBERVALIDATION_START_LOADING
} from "../actions/actionMemberValidation";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "memberValidation";

const initialState = {
    membervalidation: loadState(sessionKey, {}),
    loading: false,
    membervalidationError: ''
};

function memberValidationReducer(state = initialState, action) {

    switch (action.type) {
        case GET_MEMBERVALIDATION_START_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case GET_MEMBERVALIDATION_INFO_LOADING: {
            return {
                ...state,
                loading: true,
                membervalidationError: ''
            };
        }

        case MEMBERVALIDATION_DATA_SUCCESS: {

            saveState(sessionKey, action.payload)

            return {
                ...state,
                membervalidation: action.payload,
                loading: false,
                membervalidationError: ''
            };
        }

        case MEMBERVALIDATION_DATA_RESET: {

            saveState(sessionKey, {})

            return {
                ...state,
                loading: false,
                membervalidation: {},
                membervalidationError: ''
            }
        }

        case MEMBERVALIDATION_LOADING_RESET: {

            return {
                ...state,
                loading: false,
                membervalidationError: ''
            }
        }

        case MEMBERVALIDATION_DATA_ERROR: {

            saveState(sessionKey, action.payload)

            return {
                ...state,
                loading: false,
                membervalidation: action.payload,
                membervalidationError: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default memberValidationReducer;